import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "box"
};
var _hoisted_2 = {
  class: "content-box"
};
var _hoisted_3 = {
  class: "card-box"
};
import { toRefs, ref, computed } from 'vue';
import { getVipList } from '@/api/resources';
import { escape2Html, env_name } from '@/util/util';
import vipCard from './vipCard.vue';
export default {
  __name: 'index',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Object,
      default: function _default() {}
    },
    type: {
      type: String,
      default: 'course'
    }
  },
  emits: ['hClose'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var _toRefs = toRefs(props),
      itemData = _toRefs.itemData;
    var titleLogo = computed(function () {
      if (props.type !== 'exercise') {
        return "".concat(itemData.value.resourceName && escape2Html(itemData.value.resourceName) || itemData.value.title && escape2Html(itemData.value.title) || itemData.value.name && escape2Html(itemData.value.name), "(ID:").concat(itemData.value.uniqueCode, ")");
      } else {
        return "\u4E60\u9898ID ".concat(itemData.value.uniqueCode);
      }
    });
    var emit = __emit;
    var services = ref([]);
    var hClose = function hClose() {
      emit('hClose', false);
    };
    var loadVipList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              data = {
                periodCode: itemData.value.periodDictItemCode,
                subjectCode: itemData.value.subjectDictItemCode,
                tutorialVersionCode: itemData.value.tutorialVersionDictItemCode
              };
              _context.n = 1;
              return getVipList(data);
            case 1:
              res = _context.v;
              if (res.data.code === 0) {
                services.value = res.data.data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function loadVipList() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadVipList();
    var jumpVip = function jumpVip() {
      window.open(env_name ? "//".concat(env_name, "platform.zhixuehuijiao.cn/choiseVip?isLogin=true") : '//platform.zhixuehuijiao.cn/choiseVip?isLogin=true'); //跳转会员服务首页
    };
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_t_dialog, {
        visible: __props.dialogVisible,
        footer: false,
        closeOnEscKeydown: false,
        closeOnOverlayClick: false,
        header: "\u542B\"".concat(titleLogo.value, "\"\u7684\u4F1A\u5458\u670D\u52A1"),
        width: "63%",
        onClose: hClose
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(services.value, function (item, index) {
            return _openBlock(), _createBlock(vipCard, {
              key: index,
              data: item
            }, null, 8, ["data"]);
          }), 128))]), _createVNode(_component_t_button, {
            class: "confirm-btn",
            onClick: jumpVip
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[0] || (_cache[0] = [_createTextVNode("选择其他会员服务", -1)]));
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["visible", "header"])]);
    };
  }
};